import { useEffect, useRef } from "react";
import BannerSlider from "./Home/Banner";
import ProductShowcase from "./Home/ProductShowcase";
import { useLocation } from "react-router-dom";

export const Home = () => {
    const productRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo === "products") {
          productRef.current?.scrollIntoView({ behavior: "smooth" });
        }
      }, [location])
  
    return (<>
        <BannerSlider scrollToProducts={() => productRef.current?.scrollIntoView({ behavior: "smooth" })}/>
        <div ref={productRef}  className="pb-10">
            <ProductShowcase />
        </div>
    </>)
}

export default Home;